// extracted by mini-css-extract-plugin
export default {"link":"MVY5Lo","image":"NM_OGj","root":"v__F4U"};